import clsx from 'clsx'
import { ReactNode, useEffect, useState } from 'react'

interface tabProps {
  tabItems: {
    id: number
    title: string
    content: ReactNode
  }[]
  activeTab?: number
}

const Tabs = ({ tabItems, activeTab }: tabProps) => {
  const [active, setActive] = useState<number>(activeTab ?? 0)

  useEffect(() => {
    setActive(activeTab ?? 0)
  }, [activeTab])

  return (
    tabItems && (
      <div className="wrapper">
        <div className="tabs mb-4 flex w-full">
          {tabItems.map(({ id, title }) => (
            <TabHeader
              key={title}
              title={title}
              onItemClicked={() => setActive(id)}
              isActive={active === id}
            />
          ))}
        </div>
        <div className="content">
          {tabItems.map(({ id, content }) => {
            return active === id ? <div key={id}>{content}</div> : ''
          })}
        </div>
      </div>
    )
  )
}

const TabHeader = ({
  title = '',
  onItemClicked = () => console.error('You passed no action to the component'),
  isActive = false,
}) => {
  return (
    <div
      className={clsx(
        'flex flex-1 cursor-pointer items-center justify-center border-b-2 text-center transition-colors duration-300',
        {
          'border-gold-500 text-gold-500': isActive,
          'tabitem tabitem--inactive border-teal-500': !isActive,
        }
      )}
      onClick={onItemClicked}
    >
      <p
        className={clsx('transition-colors duration-300', {
          'text-gold-500': isActive,
          'text-teal-500': !isActive,
        })}
      >
        {title}
      </p>
    </div>
  )
}

export default Tabs
